import { render, staticRenderFns } from "./ConfirmationStep.vue?vue&type=template&id=b8f4d1f0&scoped=true"
import script from "./ConfirmationStep.vue?vue&type=script&lang=js"
export * from "./ConfirmationStep.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationStep.vue?vue&type=style&index=0&id=b8f4d1f0&prod&lang=scss&scoped=true"
import style1 from "./ConfirmationStep.vue?vue&type=style&index=1&id=b8f4d1f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f4d1f0",
  null
  
)

export default component.exports